<div class="main-content">
  <div class="left-container">
    <div class="logo-container">
      <img
        *ngIf="data | getVariantAssetForCard | async as variantAsset; else brandName"
        appImage
        class="brand-logo"
        [asset]="variantAsset"
        src=""
        alt="" />
      <ng-template #brandName>
        <div
          *ngIf="data | sectionRowViewModelBasicMethod: 'getBrand' as brand"
          appPrintCardScaleDownText
          [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
          [maxHeightInPx]="120"
          [maxWidthInPx]="80"
          class="product-card-brand"
          [style.color]="viewModel.headerTextColor$ | async">
          {{ brand }}
        </div>
      </ng-template>
    </div>
  </div>
  <div class="right-container">
    <div class="top-container">
      <div
        class="product-card-strain-type"
        *ngIf="viewModel.strainText$ | async as strainType"
        [style.background-color]="viewModel.cardAccentColor$ | async"
        [style.color]="viewModel.cardColor$ | async">
        {{ strainType | uppercase }}
      </div>

      <div class="product-name-badges-and-label-container">
        <div
          *ngIf="data | sectionRowViewModelBasicMethod: 'getRowTitle' as title"
          appPrintCardScaleDownText
          class="product-card-name"
          [maxHeightInPx]="36"
          [maxWidthInPx]="176"
          [transparentWhileScaling]="true"
          [style.color]="viewModel.headerTextColor$ | async">
          {{ title | trimSafely }}
        </div>
        <div class="badge-and-label-container">
          <div *ngIf="viewModel.hasBadges$ | async" class="badge-container">
            <img
              *ngFor="let variantBadge of data | printCardBadges"
              appImage
              class="badge"
              [asset]="variantBadge?.image"
              alt="badge"
              src="" />
          </div>

          <div>
            <app-label-inflator
              class="print-card-label"
              [columnLabel]="false"
              [labelComponentInterface]="data"
              [reset]="false">
            </app-label-inflator>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom-container">
      <div class="property-column">
        <ng-container *ngFor="let property of viewModel.propertiesBasedOnPools$ | async">
          <div class="property-container">
            <div class="title" [style.color]="viewModel.bodyTextColor$ | async">{{ property?.title }}</div>
            <div
              class="value"
              appPrintCardScaleDownText
              [maxHeightInPx]="16"
              [adjustLineHeight]="false"
              [startScalingAfterNMillisecondsAfterViewInit]="500"
              [transparentWhileScaling]="true"
              [style.color]="viewModel.bodyTextColor$ | async">
              {{ property?.value }}
            </div>
          </div>
        </ng-container>
      </div>

      <div class="size-and-price-container">
        <div
          *ngIf="
            viewModel | getExpandedGridSize: (viewModel.spoofedColViewModel$ | async) : true : false | async as size
          "
          class="product-card-size"
          [style.color]="viewModel.bodyTextColor$ | async">
          {{ size }}
        </div>

        <div class="pricing-container" [style.color]="viewModel.bodyTextColor$ | async">
          <app-column-primary-price
            [menu]="viewModel.cardStackMenu$ | async"
            [section]="viewModel.cardStack$ | async"
            [colVm]="viewModel.spoofedColViewModel$ | async"
            [rowVm]="viewModel.cardData$ | async"
            [locConfig]="viewModel.locationConfig$ | async"
            [locationId]="viewModel.locationId$ | async"
            [productStylingVm]="viewModel">
          </app-column-primary-price>
        </div>
      </div>
    </div>
  </div>
</div>
